export default "__VITE_ASSET__BqUen7rz__"